import styled from 'styled-components';

export const Content = styled.div``;

export const Action = styled.div`
  margin-top: var(--s3);
`;

/** The design's `.help` — why the control above it cannot be pressed. */
export const Help = styled.p`
  margin: var(--s2) 0 0;
  font-size: var(--fs-micro);
  line-height: var(--lh-body);
  color: var(--text-faint);
`;
